<template>
  <div class="fix-desk-download-popup dialog-scroll">
    <el-dialog center :visible.sync="dialogVisible" :before-close="handleDialogClose">
      <div>
        <!-- 検索 開始 -->
        <el-row class="m-top-2">
          <div class="top-style">
            <div class="pop-title-style">
              {{ title }}
            </div>
            <div style="display: flex">
              <lvory-but @click="handleDialogClose">
                {{ $t("button.common.cancel") }}
              </lvory-but>
            </div>
          </div>
        </el-row>

        <el-row class="m-top-2">
          <el-input
            class="user-search show-word-limt-input-iot"
            maxlength="20"
            @change="getTaxTemplateList"
            :placeholder=" $t('label.common.taxTemplatPlaceHoldere')"
            v-model="templateName"
          >
            <i slot="prefix">
              <img
                class="el-icon-search search-mirror"
                src="@/assets/icon/icon_point_search.svg"
                alt=""
              />
            </i>
          </el-input>
        </el-row>

        <el-row class="m-top-2">
          <div id="templat-search-result">
            <el-table
              show-header
              ref="table"
              :data="templatResult"
              id="search-result"
              class="table-width"
            >

              <!-- テンプレート名 -->
              <el-table-column class-name="col-5">
                <template slot="header">
                  <div>
                    <span>{{ $t('label.system.meetingRoom.taxTemplatResult.templatName') }}</span>
                    <img
                      src="@/assets/icon/bt_filter_on_off.svg"
                      style="top: 3px; left: 4px; position: relative"
                      @click="sortData('templateName')"
                    />
                  </div>
                </template>
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.templateName }}
                  </div>
                </template>
              </el-table-column>

              <!-- 消費税率 -->
              <el-table-column
                class-name="col-5"
                prop="taxRate"
                :label="$t('label.system.meetingRoom.taxTemplatResult.taxRate')"
              />

              <!-- 端数処理方法 -->
              <el-table-column
                class-name="col-5"
                prop="decimalManageMethod"
                :label="$t('label.system.meetingRoom.taxTemplatResult.decimalManageMethod')"
              />

              <el-table-column class-name="col-5">
                <div slot-scope="scope" class="detail-button with-100">
                  <sp-smart-button @click="selectTemplat(scope.row)" class="detail-button with-100">
                    {{ $t("button.common.select") }}
                  </sp-smart-button>
                </div>
              </el-table-column>


            </el-table>
          </div>
        </el-row>

        <!-- <el-row class="m-top-3 text-center text-button">
          <lvory-but class="select-btn-style" @click="userSelectList">
            {{ selectCount + "件選択" }}
          </lvory-but>
          <cancel-narrow-down class="m-top-1 link-primary" @click="handleDialogClose">
            {{ $t("button.common.cancel") }}
          </cancel-narrow-down>
        </el-row> -->
        <!-- 検索 完了 -->

        <!-- <loading-dialog class="loading_style" :dialogVisible="showLoading" /> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LvoryBut from "@/components/common/generalButton/LvoryBut";
import SpSmartButton from "@/components/common/sp-smart-button"
import SystemManageApi from "@/api/SystemManageApi";
import statusErrorCodeMsg from "@/utils/status-error-msg";
import errorCodeMsg from "@/utils/error-code-msg";
const EVENT_ON_SELECTED = "on-selected";

export default {
  components: {
    LvoryBut,
    SpSmartButton:SpSmartButton,
  },
  props: {
    title: {
      type: String,
      default: "消費税テンプレート",
    },
    ownerId:{
      type:String,
      default:null
    },
    visible: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      querys: {},
      templatResult:[],
      dialogVisible: this.visible,
      templateName:null,
      sequence: "asc",
      // showLoading:false,
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if(val){
        this.getTaxTemplateList()
      }
    },

  },
  methods: {

    getTaxTemplateList() {

      if(this.ownerId == null || this.ownerId == ''){
        this.$messageIotError(
          this.$t("オーナー未選択")
        );
        return;
      }

      this.showTableLoadingAnim();
      SystemManageApi.getTaxTemplateList({
        ownerId: this.ownerId,
        templateName: this.templateName,
        pageSize:9999,
        pageNumber:1
      })
        .catch((error) => {
          errorCodeMsg(error, this);
        })
        .then(({ data }) => {
          // 元のデータをクリアする
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.templatResult = [];
          if ( data.statusCode == "Success" && data.body.body != null && data.body.body.length > 0 ) {
            const processedIds = new Set();
            for (let index of data.body.body) {
              let decimalManageMethod = ''
              if('01' == index.decimalManageMethod){
                decimalManageMethod = '切上'
              }else if('02' == index.decimalManageMethod){
                decimalManageMethod = '切捨'
              }else if('03' == index.decimalManageMethod){
                decimalManageMethod = '四捨五入'
              }

              let taxRateT = '';
              taxRateT =  this.taxRateFormat(index.taxRate);

              this.templatResult.push({
                templateName: index.templateName,
                templateId: index.templateId,
                businessName: index.businessName,
                businessNumber: index.businessNumber,
                taxRate:taxRateT,
                decimalManageMethod:decimalManageMethod,
                specificTransactionUrl:index.specificTransactionUrl
              });
              processedIds.add(index.id);
            }
          }
          this.hideTableLoadingAnim();
        })
        .finally(() => {
          this.hideTableLoadingAnim();
        });
    },

    showTableLoadingAnim() {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: "#templat-search-result",
          background: "#ebebe6",
        });
      }
    },
    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close();
        this.tableLoadingAnim = null;
      }
    },

    handleDialogClose() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    },

    selectTemplat(templat) {
      this.dialogVisible = false;
      this.$emit(EVENT_ON_SELECTED, templat);
      this.$emit("update:visible", false);
      this.isshow = false;
    },

    sortData(key) {
      if (this.sequence === "asc") {
        this.templatResult.sort((a, b) => {
          return String(a[key]).localeCompare(
            String(b[key]),
            "ja-JP-u-ca-japanese-kf-upper"
          );
        });
        this.sequence = "desc";
      } else {
        this.templatResult.sort((a, b) => {
          return String(b[key]).localeCompare(
            String(a[key]),
            "ja-JP-u-ca-japanese-kf-upper"
          );
        });
        this.sequence = "asc";
      }
    },
    taxRateFormat(val){

      if (!val) {
        return '';
      }

      let num = Number(val) * 1000000;

      let value = num * 100 / 1000000;

      return value + '%';
    }
  },
};
</script>

<style scoped lang="scss">
.search-result-wrapper {
  height: 300px;
}
.in-floor-name {
  width: 300px;
}

::v-deep .el-dialog__header {
  text-align: left;
}
::v-deep .el-dialog__title {
  color: #7f7f7f;
  font-size: 20px;
}
::v-deep .el-dialog__headerbtn {
  display: none;
}
.checkbos {
  display: inline-block;
  width: 170px;
  ::v-deep .el-checkbox__label {
    width: 128px;
    top: 5px;
    position: absolute;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.word-size-14 {
  font-size: 14px;
}
.li-style {
  display: inline;
  line-height: 24px;
  height: auto;
  word-break: break-all;
  word-wrap: break-word;
}
.fix-desk-download-popup::v-deep {
  .el-dialog .el-dialog__header {
    margin-bottom: 30px !important;
    text-align: center;
  }
  .el-dialog__wrapper .el-dialog {
    width: 1100px !important;
  }
  .el-dialog__wrapper.loading-dialog .el-dialog {
    width: 450px !important;
  }
}

.text-center::v-deep {
  .my-button {
    width: 296px !important;
  }
}
.text-button::v-deep {
  .glance-cancel-down {
    margin-left: 0px !important;
    width: auto;
  }
}

::v-deep .el-dialog {
  padding: 43px 48px 48px 48px !important;
}
.m-bottom-35 {
  margin-bottom: 35px;
}
.m-bottom-12 {
  margin-bottom: 12px;
}
.pop-title-style {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 24px;
  font-weight: 300;
  line-height: 36px;
  text-align: left;
  color: #525250;
}
.select-btn-style {
  margin-left: 16px;
  ::v-deep .my-button {
    color: #fff;
    background-color: #329ca6;
  }
}
.top-style {
  display: flex;
  justify-content: space-between;
}
.search-mirror {
  margin-top: 14px;
  margin-left: 6px;
  margin-right: 8px;
}
.build-floor-select-style {
  width: 184px;
  margin-left: 16px;
  ::v-deep .el-input .el-input__inner {
    width: 184px !important;
  }
}

.select-btn-style ::v-deep.my-button:hover {
  color: #fff !important;
  background-color: #30969f !important;
}
</style>
